import {handleActions} from 'redux-actions';
import {TemplateData} from '../../constants/models';

const templateReducers = handleActions({
    CHAGE_TEMPLATE_TITLE: (state, {payload}) => (
        state.merge({
            title: payload
        })
    ),
    CLEAN_TIMELATE_TITLE: (state) => (
        state.merge({
            title: ''
    })
    ),
    CHAGE_TEMPLATE_MENU_BUTTON: (state, {payload}) => (
        state.merge({
            menuButton: payload
        })
    ),
    CLEAN_TIMELATE_MENU_BUTTON: (state) => (
        state.merge({
            menuButton: ''
        })
    ),
    CHAGE_TEMPLATE_BODY: (state, {payload}) => (
        state.merge({
            body: payload
        })
    ),
    CLEAN_TIMELATE_BODY: (state) => (
        state.merge({
            body: ''
        })
    ),
}, TemplateData);

export default templateReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/template/templateReducers.jsx